// Get the popup, open button, and close button
const popup = document.getElementById('popUp');
const openBtn = document.getElementById('size-popup'); // Make sure there's an element with this ID in your HTML for opening the popup
const closeBtn = document.querySelector('.section-size-cart-table .cross');

// Open popup with animation
openBtn.addEventListener('click', () => {
  popup.classList.add('show');
  document.querySelector('.pop-img').classList.add('show');
  document.querySelector('body').style.overflowY = 'hidden';
});

// Close popup with animation
closeBtn.addEventListener('click', () => {
  popup.classList.remove('show');
  document.querySelector('.pop-img').classList.remove('show');
  document.querySelector('body').style.overflowY = 'scroll';
});

// Close popup when clicking outside content
popup.addEventListener('click', (e) => {
  if (e.target === popup) {
    popup.classList.remove('show');
    document.querySelector('.pop-img').classList.remove('show');
    document.querySelector('body').style.overflowY = 'scroll';
  }
});
